import { getResponseHeader, setResponseHeader } from 'h3';

export const CacheTagPrefix = {
  View: 'view',
  Block: 'block',
  Product: 'product',
} as const;

export type CacheTagPrefixValue = typeof CacheTagPrefix[keyof typeof CacheTagPrefix];

export type CacheTag = {
  prefix: CacheTagPrefixValue;
  value: string;
};

type CacheContext = {
  __pageHtmlCacheTags?: string[];
};

function toCacheTagString(tag: CacheTag): string {

  return `${tag.prefix}:${tag.value}`;

}

function uniqueStrings(values: string[]): string[] {

  return Array.from(new Set(values));

}

export function useCache(): { addTags: (tags: CacheTag[]) => void } {

  let event: ReturnType<typeof useRequestEvent> | undefined;

  if (import.meta.server) {

    try {

      event = useRequestEvent();

    } catch {

      event = undefined;

    }

  }

  const addTags = (tags: CacheTag[]): void => {

    if (!import.meta.server) {

      return;

    }

    if (!event) {

      return;

    }

    const context = event.context as CacheContext;

    const normalized = tags
      .map(toCacheTagString)
      .map(s => s.trim())
      .filter(Boolean);

    if (!normalized.length) {

      return;

    }

    const current = Array.isArray(context.__pageHtmlCacheTags) ? context.__pageHtmlCacheTags : [];
    const merged = uniqueStrings([...current, ...normalized]);
    context.__pageHtmlCacheTags = merged;

    // Optional: also expose tags as a response header for debugging/infra.
    const existingHeader = String(getResponseHeader(event, 'x-cache-tags') || '');
    const existing = existingHeader
      .split(',')
      .map(s => s.trim())
      .filter(Boolean);

    const headerTags = uniqueStrings([...existing, ...merged]);

    if (!event.node.res.headersSent) {

      setResponseHeader(event, 'x-cache-tags', headerTags.join(','));

    }

  };

  return { addTags };

}
